import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, Typography } from '@mui/material';
import { ONIX_IMAGE } from '@src/constants';
import { useTranslation } from 'next-i18next';
interface NeedsBasedQuestion {
  description?: string | null;
  questionId: string;
  onChangeCallback: (value: string[], questionId: string) => void;
  value: string[];
  hasError?: boolean;
  question: any;
}
export default function OnixCard({
  questionId,
  description,
  question,
  onChangeCallback,
  value,
  hasError
}: NeedsBasedQuestion) {
  const {
    t
  } = useTranslation();
  const valueArray = Array.isArray(value) ? value : [];
  const showError = !!hasError && valueArray.length === 0;
  const selectedValue = valueArray[0];
  const options = question?.answer?.answers || [];
  const handleChange = (answerId: string) => {
    const newValue = selectedValue === answerId ? [] : [answerId];
    onChangeCallback(newValue, questionId);
  };
  const labelId = 'onix-checkbox-label';
  return <Box sx={{
    borderRadius: '1rem',
    background: '#004BB9',
    padding: {
      xs: '0.75rem 1rem 0 1rem',
      sm: '1rem'
    },
    display: 'flex',
    flexDirection: {
      xs: 'column',
      sm: 'row'
    },
    marginBottom: {
      xs: '1rem',
      sm: '2rem'
    },
    width: 'calc(100% + 16px)'
  }} data-sentry-element="Box" data-sentry-component="OnixCard" data-sentry-source-file="OnixCard.tsx">
			<Box data-test-id="onix-card" sx={{
      width: '100%'
    }} data-sentry-element="Box" data-sentry-source-file="OnixCard.tsx">
				<Box sx={{
        display: 'flex',
        flexDirection: {
          xs: 'column',
          md: 'row'
        },
        gap: '1rem'
      }} data-sentry-element="Box" data-sentry-source-file="OnixCard.tsx">
					<Box component="img" src={ONIX_IMAGE.src} alt={ONIX_IMAGE.alt} data-test-id="desktop-onix-image" sx={{
          display: {
            xs: 'none',
            md: 'block'
          },
          width: {
            xs: '84px',
            md: '244px'
          },
          height: {
            xs: '84px',
            md: '244px'
          },
          objectFit: 'cover',
          borderRadius: '1rem',
          flexShrink: 0
        }} data-sentry-element="Box" data-sentry-source-file="OnixCard.tsx" />

					<Box sx={{
          flex: 1
        }} data-sentry-element="Box" data-sentry-source-file="OnixCard.tsx">
						<Box sx={{
            display: {
              xs: 'flex',
              md: 'none'
            },
            alignItems: 'center'
          }} data-sentry-element="Box" data-sentry-source-file="OnixCard.tsx">
							<Box component="img" src={ONIX_IMAGE.src} alt={ONIX_IMAGE.alt} sx={{
              width: '84px',
              height: '84px',
              objectFit: 'cover',
              borderRadius: '1rem',
              marginRight: '.75rem'
            }} data-sentry-element="Box" data-sentry-source-file="OnixCard.tsx" />
							<Typography variant="header3" color="text.light" data-sentry-element="Typography" data-sentry-source-file="OnixCard.tsx">
								{description}
							</Typography>
						</Box>

						<Box sx={{
            display: {
              xs: 'none',
              md: 'block'
            },
            mb: '0.5rem'
          }} data-sentry-element="Box" data-sentry-source-file="OnixCard.tsx">
							<Typography id={labelId} variant="header3" color="text.light" data-sentry-element="Typography" data-sentry-source-file="OnixCard.tsx">
								{description}
							</Typography>
						</Box>

						<Typography variant="bodyMediumBook" color="text.light" data-sentry-element="Typography" data-sentry-source-file="OnixCard.tsx">
							Discover Onix Fixed, our most permanent, secure and durable smile built with cutting-edge
							technology that feels closest to your natural teeth.
						</Typography>

						<Box sx={{
            mb: {
              xs: '0.5rem',
              md: 0
            }
          }} data-sentry-element="Box" data-sentry-source-file="OnixCard.tsx">
							<FormControl component="fieldset" required error={showError} aria-labelledby={labelId} data-sentry-element="FormControl" data-sentry-source-file="OnixCard.tsx">
								<FormGroup data-sentry-element="FormGroup" data-sentry-source-file="OnixCard.tsx">
									{options.map((option: any) => <FormControlLabel key={option.answerId} control={<Checkbox sx={{
                  color: 'text.light',
                  '&.Mui-checked': {
                    color: 'text.light'
                  }
                }} checked={selectedValue === option.answerId} onChange={() => handleChange(option.answerId)} />} label={<Typography variant="bodyMediumBook" color="text.light">
													{option.description}
												</Typography>} />)}
								</FormGroup>

								{showError && <FormHelperText sx={{
                marginLeft: '0rem'
              }}>
										<Typography variant="errorValidation" color="text.light">
											{t('Required')}
										</Typography>
									</FormHelperText>}
							</FormControl>
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>;
}